import CommunityHeatmap from './CommunityHeatmap';

export default CommunityHeatmap;
